module.exports = __webpack_public_path__ + "img/warning.623e7272.svg";